/* RocketFuel language & country sheet. Markup and styles: snippets/rf-lang-switch.liquid */
(function () {
  if (window.rfLangInit) return;
  window.rfLangInit = true;

  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function formOf(el) { return el && el.closest ? el.closest('[data-rf-lang-form]') : null; }

  function closePopovers() {
    document.querySelectorAll('details[data-rf-lang][open]').forEach(function (d) { d.removeAttribute('open'); });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-rf-lang][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- Popup language ----------
     Picking a language card switches the popup itself to that language right
     away (before Apply): labels, buttons, the request card and the country
     names (from the browser's Intl.DisplayNames), re-sorted alphabetically
     with the current country first.
     Keep these strings in sync with the Liquid defaults in rf-lang-switch.liquid.
     title is the sheet headline; label and country only name the two radio groups
     for screen readers (not shown). */
  var I18N = {
    en: {
      title: 'Region & language', close: 'Close',
      label: 'Language', country: 'Country', search: 'Search country', apply: 'Apply', cancel: 'Cancel',
      empty: 'No country found', reqTitle: 'Country not listed?',
      reqSub: 'Leave your country and email. We will check whether we can add it and get back to you.',
      reqCountry: 'Country', reqEmail: 'Email address', reqBtn: 'Request', reqSend: 'Send', reqSending: 'Sending …',
      reqOk: 'Thanks! We will check whether we can add your country and get back to you.',
      reqInvalid: 'Please enter your country and a valid email address.',
      reqFail: 'That did not work. Please email us at', reqPrivacy: 'We only use your email to reply to your request.'
    },
    de: {
      title: 'Land & Sprache', close: 'Schließen',
      label: 'Sprache', country: 'Land', search: 'Land suchen', apply: 'Übernehmen', cancel: 'Abbrechen',
      empty: 'Kein Land gefunden', reqTitle: 'Dein Land fehlt?',
      reqSub: 'Hinterlass dein Land und deine E-Mail. Wir prüfen, ob wir es aufnehmen können, und melden uns bei dir.',
      reqCountry: 'Land', reqEmail: 'E-Mail-Adresse', reqBtn: 'Anfragen', reqSend: 'Senden', reqSending: 'Wird gesendet …',
      reqOk: 'Danke! Wir prüfen, ob wir dein Land aufnehmen können, und melden uns bei dir.',
      reqInvalid: 'Bitte gib dein Land und eine gültige E-Mail-Adresse ein.',
      reqFail: 'Das hat leider nicht geklappt. Schreib uns gern an', reqPrivacy: 'Wir nutzen deine E-Mail nur, um dir auf deine Anfrage zu antworten.'
    },
    fr: {
      title: 'Pays et langue', close: 'Fermer',
      label: 'Langue', country: 'Pays', search: 'Rechercher un pays', apply: 'Appliquer', cancel: 'Annuler',
      empty: 'Aucun pays trouvé', reqTitle: 'Votre pays n’est pas dans la liste ?',
      reqSub: 'Laissez votre pays et votre e-mail. Nous vérifions si nous pouvons l’ajouter et nous revenons vers vous.',
      reqCountry: 'Pays', reqEmail: 'Adresse e-mail', reqBtn: 'Demander', reqSend: 'Envoyer', reqSending: 'Envoi …',
      reqOk: 'Merci ! Nous vérifions si nous pouvons ajouter votre pays et revenons vers vous.',
      reqInvalid: 'Veuillez indiquer votre pays et une adresse e-mail valide.',
      reqFail: 'Cela n’a pas fonctionné. Écrivez-nous à', reqPrivacy: 'Nous utilisons votre e-mail uniquement pour répondre à votre demande.'
    }
  };

  function setText(root, sel, text) {
    var el = q(root, sel);
    if (el && text) el.textContent = text;
  }

  function setField(root, sel, text) {
    var el = q(root, sel);
    if (!el || !text) return;
    el.setAttribute('placeholder', text);
    el.setAttribute('aria-label', text);
  }

  function regionNames(lang) {
    try { return new Intl.DisplayNames([lang], { type: 'region' }); } catch (e) { return null; }
  }

  function uiLang(form) {
    return form.getAttribute('data-ui-lang') || form.getAttribute('data-cur-lang') || 'en';
  }

  function setUiLang(form, lang) {
    if (!form || form.getAttribute('data-ui-lang') === lang) return;
    form.setAttribute('data-ui-lang', lang);
    var cur = form.getAttribute('data-cur-lang');
    var t = I18N[lang] || I18N.en;

    setText(form, '.rf-lang__title', t.label);
    setText(form, '.rf-lang__country-label', t.country);
    setField(form, '[data-rf-country-search]', t.search);
    setText(form, '[data-rf-empty]', t.empty);
    setText(form, '[data-rf-cancel]', t.cancel);
    setText(form, '[data-rf-apply]', t.apply);

    var box = q(form, '[data-rf-req]');
    if (box) {
      setText(box, '.rf-lang__req-title', t.reqTitle);
      setText(box, '.rf-lang__req-sub', t.reqSub);
      setText(box, '.rf-lang__req-note', t.reqPrivacy);
      setText(box, '[data-rf-req-open]', t.reqBtn);
      if (!box.classList.contains('is-busy')) setText(box, '[data-rf-req-send]', t.reqSend);
      setField(box, '[data-rf-req-country]', t.reqCountry);
      setField(box, '[data-rf-req-email]', t.reqEmail);
      box.setAttribute('data-t-sending', t.reqSending);
      box.setAttribute('data-t-ok', t.reqOk);
      box.setAttribute('data-t-invalid', t.reqInvalid);
      box.setAttribute('data-t-fail', t.reqFail);
      if (box.classList.contains('is-sent')) requestMsg(box, t.reqOk, 'ok');
    }

    /* Country names: Shopify's own names for the page language, the browser's for any other. */
    var list = q(form, '[data-rf-country-list]');
    if (list) {
      var names = lang === cur ? null : regionNames(lang);
      var items = qa(list, '.rf-lang__citem');
      items.forEach(function (item, i) {
        var nameEl = q(item, '.rf-lang__cname');
        var radio = q(item, '.rf-lang__radio');
        if (!item.hasAttribute('data-name-orig')) {
          item.setAttribute('data-name-orig', nameEl.textContent);
          item.setAttribute('data-idx', String(i));
        }
        var name = item.getAttribute('data-name-orig');
        if (names) {
          try { name = names.of(radio.value) || name; } catch (e) {}
        }
        nameEl.textContent = name;
        radio.setAttribute('data-label', name);
        var key = item.getAttribute('data-name');
        if (key.indexOf('|' + name.toLowerCase() + '|') === -1 && key.indexOf(name.toLowerCase() + '|') !== 0) {
          item.setAttribute('data-name', key + '|' + name.toLowerCase());
        }
      });
      /* Order: the shopper's current country, then the countries most people
         order from (same for every language),
         a thin line, then everything else A to Z. The top block is always 8
         rows (four full rows in the two-column list on desktop). */
      var curCountry = form.getAttribute('data-cur-country');
      var present = {};
      items.forEach(function (item) { present[q(item, '.rf-lang__radio').value] = true; });
      /* Same order in every language (Oct 6 2026, Raphael): switching DE/EN must not move
         tiles (CH and AT swapped places and a tap landed on the wrong country). So: the
         current (auto detected) country, then the main markets by order volume. */
      var wanted = [curCountry].concat(popularCountries());
      var pinCount = PIN_COUNT;
      var rank = {};
      var pinned = 0;
      wanted.forEach(function (code) {
        if (pinned < pinCount && present[code] && !(code in rank)) rank[code] = pinned++;
      });
      items.sort(function (a, b) {
        var ac = q(a, '.rf-lang__radio').value;
        var bc = q(b, '.rf-lang__radio').value;
        var ar = ac in rank ? rank[ac] : 999;
        var br = bc in rank ? rank[bc] : 999;
        if (ar !== br) return ar - br;
        if (lang === cur) return Number(a.getAttribute('data-idx')) - Number(b.getAttribute('data-idx'));
        return q(a, '.rf-lang__cname').textContent.localeCompare(q(b, '.rf-lang__cname').textContent, lang);
      });
      var sep = q(list, '.rf-lang__csep');
      if (!sep) {
        sep = document.createElement('div');
        sep.className = 'rf-lang__csep';
        sep.setAttribute('aria-hidden', 'true');
        sep.style.cssText = 'grid-column:1/-1;height:1px;margin:8px 12px;background:var(--rf-line, rgb(17 17 17 / 0.12));';
      }
      items.forEach(function (item, i) {
        if (i === pinned && pinned > 0 && pinned < items.length) list.appendChild(sep);
        list.appendChild(item);
      });
    }

    var dlg = form.closest('.rf-lang-sheet');
    if (dlg) {
      setText(dlg, '[data-rf-sheet-title]', list ? t.title : t.label);
      var x = q(dlg, '[data-rf-sheet-close]');
      if (x && t.close) x.setAttribute('aria-label', t.close);
    }
  }

  /* Favourites on top of the country list: always 8 rows. */
  var PIN_COUNT = 8;
  /* Most ordered-from countries. The live list comes from the shop metafield
     rocketfuel.popular_countries (orders by shipping country, last 90 days), which
     a scheduled task refreshes every week; snippets/rf-site-fixes.liquid puts it on
     window.rfPopularCountries. This list is only the fallback (90 days to 5 Oct 2026:
     DE 318, CH 136, AT 47, CY 20, BE 20, NL 19, IT 19, NO 17, FR 17, SE 12). */
  var POPULAR_FALLBACK = ['DE', 'CH', 'AT', 'CY', 'BE', 'NL', 'IT', 'NO', 'FR', 'SE', 'PT', 'SI'];
  function popularCountries() {
    var list = window.rfPopularCountries;
    if (Array.isArray(list) && list.length) {
      var clean = list.map(function (c) { return String(c || '').toUpperCase(); }).filter(function (c) { return /^[A-Z]{2}$/.test(c); });
      if (clean.length) return clean.concat(POPULAR_FALLBACK);
    }
    return POPULAR_FALLBACK;
  }

  /* ---------- Selection state ---------- */

  function checked(form, list) {
    return q(form, '[' + list + '] .rf-lang__radio:checked');
  }

  function updateSummary(form) {
    var c = checked(form, 'data-rf-country-list');
    var l = checked(form, 'data-rf-lang-list');
    var parts = [];
    if (c) parts.push(c.getAttribute('data-label'));
    if (l) parts.push(l.getAttribute('data-label'));
    var s = q(form, '[data-rf-summary]');
    if (s) s.textContent = parts.join(' · ');
    var changed = (c && c.value !== form.getAttribute('data-cur-country')) ||
      (l && norm(l.value) !== norm(form.getAttribute('data-cur-lang')));
    form.classList.toggle('is-changed', !!changed);
    var btn = q(form, '[data-rf-apply]');
    if (btn) btn.disabled = !changed;
  }

  function filter(form, value) {
    var needle = String(value || '').trim().toLowerCase();
    var shown = 0;
    qa(form, '[data-rf-country-list] .rf-lang__citem').forEach(function (item) {
      var hide = needle !== '' && item.getAttribute('data-name').indexOf(needle) === -1;
      item.hidden = hide;
      if (!hide) shown++;
    });
    var sep = q(form, '[data-rf-country-list] .rf-lang__csep');
    if (sep) sep.hidden = needle !== '';
    var empty = q(form, '[data-rf-empty]');
    if (empty) empty.hidden = shown !== 0;
    syncRequest(form, value, shown);
  }

  /* ---------- Country request ---------- */

  /* Collapsed shows only "Request"; open shows the fields and "Send". */
  function setRequestOpen(box, open, auto) {
    box.classList.toggle('is-open', open);
    if (open && auto) box.setAttribute('data-auto-open', '');
    if (!open || !auto) box.removeAttribute('data-auto-open');
    var opener = q(box, '[data-rf-req-open]');
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function syncRequest(form, raw, shown) {
    var box = q(form, '[data-rf-req]');
    if (!box) return;
    var input = q(box, '[data-rf-req-country]');
    var email = q(box, '[data-rf-req-email]');
    var v = String(raw || '').trim();
    var none = v !== '' && shown === 0;
    box.classList.toggle('is-highlight', none);
    if (none) {
      if (!input.value || input.hasAttribute('data-auto')) {
        input.value = v.charAt(0).toUpperCase() + v.slice(1);
        input.setAttribute('data-auto', '');
      }
      if (!box.classList.contains('is-open')) setRequestOpen(box, true, true);
    } else {
      if (input.hasAttribute('data-auto')) {
        input.value = '';
        input.removeAttribute('data-auto');
      }
      /* Opened only because the search found nothing: fold it away again once results are back. */
      if (box.hasAttribute('data-auto-open') && !email.value.trim() && !input.value.trim()) setRequestOpen(box, false);
    }
  }

  function focusRequest(form) {
    var box = q(form, '[data-rf-req]');
    if (!box || box.classList.contains('is-sent')) return false;
    if (!box.classList.contains('is-open')) setRequestOpen(box, true, false);
    var c = q(box, '[data-rf-req-country]');
    var target = c.value.trim() ? q(box, '[data-rf-req-email]') : c;
    target.focus({ preventScroll: true });
    box.scrollIntoView({ block: 'nearest' });
    return true;
  }

  function requestMsg(box, text, kind, mailto) {
    var msg = q(box, '[data-rf-req-msg]');
    msg.textContent = text;
    msg.className = 'rf-lang__req-msg' + (kind ? ' is-' + kind : '');
    if (mailto) {
      var a = document.createElement('a');
      a.href = mailto;
      a.textContent = 'info@rocketfuelendurance.com';
      msg.appendChild(document.createTextNode(' '));
      msg.appendChild(a);
      msg.appendChild(document.createTextNode('.'));
    }
    msg.hidden = !text;
  }

  function sendRequest(box) {
    if (box.classList.contains('is-busy') || box.classList.contains('is-sent')) return;
    var form = formOf(box);
    var c = q(box, '[data-rf-req-country]');
    var em = q(box, '[data-rf-req-email]');
    var btn = q(box, '[data-rf-req-send]');
    var country = c.value.trim();
    var email = em.value.trim();
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!country || !emailOk) {
      requestMsg(box, box.getAttribute('data-t-invalid'), 'error');
      (country ? em : c).focus();
      return;
    }
    var mailto = 'mailto:info@rocketfuelendurance.com?subject=' + encodeURIComponent('Country request: ' + country) +
      '&body=' + encodeURIComponent('Country: ' + country + '\nEmail: ' + email);
    var label = btn.textContent;
    var fail = function () {
      box.classList.remove('is-busy');
      btn.disabled = false;
      btn.textContent = label;
      requestMsg(box, box.getAttribute('data-t-fail'), 'error', mailto);
    };
    var endpoint = box.getAttribute('data-endpoint');
    if (!endpoint) { fail(); return; }
    box.classList.add('is-busy');
    btn.disabled = true;
    btn.textContent = box.getAttribute('data-t-sending');
    requestMsg(box, '');
    var body = new URLSearchParams();
    body.append('type', 'country_request');
    body.append('country', country);
    body.append('email', email);
    body.append('lang', form ? uiLang(form) : '');
    body.append('store_country', form ? form.getAttribute('data-cur-country') : '');
    body.append('page', location.href.split('?')[0]);
    body.append('ua', navigator.userAgent);
    body.append('website', q(box, '[data-rf-req-hp]').value);
    fetch(endpoint, { method: 'POST', body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || !res.ok) throw new Error('rejected');
        box.classList.remove('is-busy');
        box.classList.add('is-sent');
        requestMsg(box, box.getAttribute('data-t-ok'), 'ok');
      })
      .catch(fail);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-rf-req-open]');
    if (opener) {
      e.preventDefault();
      focusRequest(formOf(opener));
      return;
    }
    var send = e.target.closest && e.target.closest('[data-rf-req-send]');
    if (!send) return;
    e.preventDefault();
    sendRequest(send.closest('[data-rf-req]'));
  });

  function resetForm(form) {
    qa(form, '.rf-lang__radio').forEach(function (r) { r.checked = r.defaultChecked; });
    setUiLang(form, form.getAttribute('data-cur-lang') || 'en');
    var s = q(form, '[data-rf-country-search]');
    if (s) s.value = '';
    filter(form, '');
    form.classList.remove('is-busy');
    var box = q(form, '[data-rf-req]');
    if (box && !box.classList.contains('is-sent')) {
      requestMsg(box, '');
      setRequestOpen(box, false);
    }
    updateSummary(form);
  }

  function visibleCountries(form) {
    return qa(form, '[data-rf-country-list] .rf-lang__citem:not([hidden]) .rf-lang__radio');
  }

  function columns(form) {
    var list = q(form, '[data-rf-country-list]');
    if (!list) return 1;
    var cols = getComputedStyle(list).gridTemplateColumns.split(' ').filter(Boolean).length;
    return cols || 1;
  }

  function pick(radio) {
    radio.checked = true;
    try { radio.focus({ preventScroll: true }); } catch (e) { radio.focus(); }
    var tile = radio.closest('label');
    if (tile && tile.scrollIntoView) tile.scrollIntoView({ block: 'nearest' });
    updateSummary(formOf(radio));
  }

  /* ---------- Apply / cancel ---------- */

  /* Two-letter language code: Shopify's preview links report 'de-EU' instead of 'de'. */
  function norm(code) {
    return String(code || '').slice(0, 2).toLowerCase();
  }

  /* /de-eu/products/x -> /products/x. Read from the URL itself: on preview links
     Shopify.routes.root (/de/) does not match the prefix in the address (/de-eu/). */
  function pathWithoutLocale(path) {
    var parts = String(path || '/').split('/');
    if (parts.length > 1 && /^[a-z]{2}(-[a-z]{2})?$/i.test(parts[1])) parts.splice(1, 1);
    var out = parts.join('/');
    return out ? (out.charAt(0) === '/' ? out : '/' + out) : '/';
  }

  /* Returns true when the native submit (country change) should go ahead. */
  function apply(form) {
    var c = checked(form, 'data-rf-country-list');
    var l = checked(form, 'data-rf-lang-list');
    var curC = form.getAttribute('data-cur-country');
    var curL = norm(form.getAttribute('data-cur-lang'));
    var cc = c ? c.value : curC;
    var lc = l ? l.value : curL;
    if (cc === curC && norm(lc) === curL) {
      closeAll();
      return false;
    }
    form.classList.add('is-busy');
    if (cc !== curC) {
      /* Country (and maybe language): the country is saved with a background post
         to /localization, then we go straight to the page in the chosen language.
         Relying on Shopify's redirect alone sometimes brought the shopper back in
         the old language (or with the old country), so the result was half applied. */
      q(form, '[data-rf-country-input]').value = cc;
      q(form, '[data-rf-language-input]').value = lc;
      var rt = q(form, 'input[name="return_to"]');
      if (rt) rt.value = pathWithoutLocale(window.location.pathname) + window.location.search;
      try { sessionStorage.setItem('rfWant', JSON.stringify({ c: cc, l: norm(lc) })); } catch (e) {}
      var target = (norm(lc) !== curL && l && l.getAttribute('data-href')) || window.location.pathname;
      target += window.location.search;
      var native = function () { HTMLFormElement.prototype.submit.call(form); };
      if (!window.fetch || !window.FormData) {
        native();
        return false;
      }
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'manual' })
        .then(function () { window.location.href = target; })
        .catch(native);
      return false;
    }
    window.location.href = l.getAttribute('data-href');
    return false;
  }

  function submitForm(form) {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else if (apply(form)) {
      form.submit();
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-rf-lang-form]')) return;
    if (!apply(form)) e.preventDefault();
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('rf-lang__radio')) return;
    if (t.closest('[data-rf-lang-list]')) setUiLang(formOf(t), norm(t.value));
    updateSummary(formOf(t));
  });

  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (inp.matches && inp.matches('[data-rf-req-country]')) inp.removeAttribute('data-auto');
    if (!inp.matches || !inp.matches('[data-rf-country-search]')) return;
    filter(formOf(inp), inp.value);
  });

  document.addEventListener('click', function (e) {
    var cancel = e.target.closest && e.target.closest('[data-rf-cancel]');
    if (!cancel) return;
    e.preventDefault();
    closeAll();
  });

  /* Double-click a country to apply it straight away. */
  document.addEventListener('dblclick', function (e) {
    var tile = e.target.closest && e.target.closest('[data-rf-country-list] .rf-lang__citem');
    if (!tile) return;
    var r = q(tile, '.rf-lang__radio');
    r.checked = true;
    submitForm(formOf(r));
  });

  /* ---------- Keyboard ---------- */

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePopovers(); return; }
    var t = e.target;
    var form = formOf(t);
    if (!form) return;

    var reqBox = t.closest('[data-rf-req]');
    if (reqBox) {
      if (e.key === 'Enter' && t.matches('[data-rf-req-open]')) {
        e.preventDefault();
        focusRequest(form);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        sendRequest(reqBox);
      }
      return;
    }

    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      submitForm(form);
      return;
    }

    if (t.matches('[data-rf-country-search]')) {
      if (e.key !== 'ArrowDown' && e.key !== 'Enter') return;
      e.preventDefault();
      var vis = visibleCountries(form);
      if (!vis.length) { focusRequest(form); return; }
      var target = vis[0];
      if (e.key === 'ArrowDown' && !t.value.trim()) {
        target = vis.filter(function (r) { return r.checked; })[0] || vis[0];
      }
      pick(target);
      return;
    }

    if (!t.classList || !t.classList.contains('rf-lang__radio')) return;

    if (e.key === 'Enter') {
      e.preventDefault();
      t.checked = true;
      updateSummary(form);
      submitForm(form);
      return;
    }

    if (!t.closest('[data-rf-country-list]')) return;

    var search = q(form, '[data-rf-country-search]');
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) !== -1) {
      e.preventDefault();
      var list = visibleCountries(form);
      var i = list.indexOf(t);
      var cols = columns(form);
      var j = i;
      if (e.key === 'ArrowLeft') j = i - 1;
      else if (e.key === 'ArrowRight') j = i + 1;
      else if (e.key === 'ArrowUp') j = i - cols;
      else j = i + cols;
      if (j < 0) {
        if (search && (e.key === 'ArrowUp' || e.key === 'ArrowLeft')) search.focus();
        return;
      }
      if (j >= list.length) {
        if (e.key !== 'ArrowDown') return;
        if (Math.floor(i / cols) >= Math.floor((list.length - 1) / cols)) { focusRequest(form); return; }
        j = list.length - 1;
      }
      pick(list[j]);
      return;
    }

    /* Typing a letter on a tile continues the search. */
    if (search && e.key.length === 1 && e.key !== ' ' && !e.metaKey && !e.ctrlKey && !e.altKey) {
      search.focus();
      var len = search.value.length;
      try { search.setSelectionRange(len, len); } catch (err) {}
    }
  });

  /* ---------- Sheet ----------
     The panel (language switch + country list) in a modal, so the shopper does not
     have to be scrolled up to the header. Opened by "Change" in the shipping
     block and by the header / footer flag on every screen size. The panel is
     moved into the sheet while it is open and put back on close, so there is
     only ever one copy of the localization form on the page. */
  var sheet = null;
  var sheetBody = null;
  var sheetPlaceholder = null;

  /* One short headline ("Region & language" / "Land & Sprache"), rendered by Liquid on the panel. */
  function sheetTitle(panel) {
    var t = panel.getAttribute('data-rf-title');
    if (t) return t;
    var l = panel.querySelector('.rf-lang__title');
    return l ? l.textContent.trim() : 'Language';
  }

  function closeAll() {
    if (sheet && sheet.open) {
      sheet.close();
    } else {
      document.querySelectorAll('details[data-rf-lang][open]').forEach(function (d) {
        d.removeAttribute('open');
        var f = q(d, '[data-rf-lang-form]');
        if (f) resetForm(f);
      });
    }
  }

  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('dialog');
    sheet.className = 'rf-lang-sheet';
    sheet.setAttribute('data-rf-lang-sheet', '');
    sheet.setAttribute('autofocus', '');
    sheet.setAttribute('aria-labelledby', 'rf-lang-sheet-title');
    sheet.innerHTML =
      '<div class="rf-lang-sheet__head"><h2 class="rf-lang-sheet__title" id="rf-lang-sheet-title" data-rf-sheet-title></h2>' +
      '<button type="button" class="rf-lang-sheet__close" data-rf-sheet-close aria-label="Close">' +
      '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>' +
      '<div class="rf-lang-sheet__body" data-rf-sheet-body></div>';
    document.body.appendChild(sheet);
    sheetBody = sheet.querySelector('[data-rf-sheet-body]');
    sheet.querySelector('[data-rf-sheet-close]').addEventListener('click', function () { sheet.close(); });
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) sheet.close();
    });
    sheet.addEventListener('close', function () {
      document.documentElement.classList.remove('rf-lang-sheet-lock');
      /* The dialog hands focus back to the flag button, which then shows its keyboard focus ring. */
      var dropFocus = function () {
        var a = document.activeElement;
        if (a && a.closest && (a.closest('details[data-rf-lang]') || a.closest('[data-rf-change]'))) a.blur();
      };
      dropFocus();
      setTimeout(dropFocus, 0);
      var panel = sheetBody.firstElementChild;
      if (panel) {
        var f = q(panel, '[data-rf-lang-form]');
        if (f && !f.classList.contains('is-busy')) resetForm(f);
      }
      if (panel && sheetPlaceholder && sheetPlaceholder.parentNode) {
        sheetPlaceholder.parentNode.replaceChild(panel, sheetPlaceholder);
      }
      sheetPlaceholder = null;
    });
    return sheet;
  }

  function pickSource() {
    var all = Array.prototype.filter.call(document.querySelectorAll('details[data-rf-lang]'), function (d) {
      return d.querySelector('.rf-lang__panel');
    });
    var withCountry = all.filter(function (d) { return d.querySelector('.rf-lang__country'); });
    var list = withCountry.length ? withCountry : all;
    return list.filter(function (d) { return d.closest('#header-group, header, .header-section'); })[0] || list[0] || null;
  }

  function openSheet(source) {
    source = source || pickSource();
    if (!source) return false;
    var panel = source.querySelector('.rf-lang__panel');
    if (!panel) return false;
    var dlg = ensureSheet();
    if (dlg.open) return true;
    source.removeAttribute('open');
    sheetPlaceholder = document.createComment('rf-lang-panel');
    panel.parentNode.replaceChild(sheetPlaceholder, panel);
    sheetBody.innerHTML = '';
    sheetBody.appendChild(panel);
    dlg.querySelector('[data-rf-sheet-title]').textContent = sheetTitle(panel);
    var form = panel.querySelector('[data-rf-lang-form]');
    if (form) {
      form.removeAttribute('data-ui-lang');
      resetForm(form);
    }
    try { dlg.showModal(); } catch (e) { return false; }
    document.documentElement.classList.add('rf-lang-sheet-lock');
    sheetBody.scrollTop = 0;
    var search = panel.querySelector('[data-rf-country-search]');
    if (search && window.matchMedia('(min-width: 750px)').matches) {
      try { search.focus({ preventScroll: true }); } catch (e2) {}
    }
    return true;
  }

  window.rfLangSheet = { open: openSheet };

  /* Safety net after a country change: if the page does not show the chosen
     country and language, post both once more the classic way (form submit).
     The flag is cleared first, so this can never loop. */
  (function () {
    var want = null;
    try {
      want = JSON.parse(sessionStorage.getItem('rfWant') || 'null');
      sessionStorage.removeItem('rfWant');
    } catch (e) {}
    if (!want || !want.c) return;
    var form = q(document, '[data-rf-lang-form]');
    if (!form) return;
    var okC = form.getAttribute('data-cur-country') === want.c;
    var okL = !want.l || norm(form.getAttribute('data-cur-lang')) === want.l;
    if (okC && okL) return;
    var radio = qa(form, '[data-rf-lang-list] .rf-lang__radio').filter(function (r) { return norm(r.value) === want.l; })[0];
    q(form, '[data-rf-country-input]').value = want.c;
    q(form, '[data-rf-language-input]').value = radio ? radio.value : form.getAttribute('data-cur-lang');
    var rt = q(form, 'input[name="return_to"]');
    if (rt) rt.value = (radio && radio.getAttribute('data-href')) || (pathWithoutLocale(window.location.pathname) + window.location.search);
    HTMLFormElement.prototype.submit.call(form);
  })();

  /* Back/forward cache: never come back to a half-submitted sheet. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (sheet && sheet.open) sheet.close();
    qa(document, '[data-rf-lang-form]').forEach(resetForm);
  });

  /* Flag button (header and footer): the sheet instead of the small popover, on every screen size. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('details[data-rf-lang] > .rf-lang__btn');
    if (!btn) return;
    var details = btn.parentElement;
    if (!details.querySelector('.rf-lang__panel')) return;
    e.preventDefault();
    openSheet(details);
  }, true);
})();
